<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.922 6.834c-6.235 0-11.531 3.825-13.412 9.139L2.5 16l.01.027c1.88 5.314 7.177 9.14 13.412 9.14 6.235 0 11.53-3.826 13.412-9.14l.01-.027-.01-.028c-1.881-5.314-7.177-9.139-13.412-9.139zm-5.25 8.917a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm5.25-3.417a3.417 3.417 0 100 6.833 3.417 3.417 0 000-6.833z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsEyeFilled'
}
</script>
